import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { StatTile, ViewTitle } from '../../../../reusable'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import api from '../../../../../helpers/apiRequester'
import Select from 'react-select'
import { title } from 'process'
export interface statsProps {
    data: any
}
export interface stepInferface {
    title: string
    progress: string
}
export const ProgressView = (props: statsProps) => {
    const navigate = useNavigate()
    const { data } = props
    const [steps, setSteps] = useState<Array<stepInferface>>([])

    const progressItems: any = {
        incomplete: (
            <>
                <div className={styles.incomplete}></div>
            </>
        ),
        complete: (
            <>
                <div className={styles.complete}></div>
            </>
        ),
        cancelled: (
            <>
                <div className={styles.cancelled}></div>
            </>
        ),
    }

    useEffect(() => {
        console.log('DATAVIEW : ', data)

        let ccResult = data.full_credit_check_request
        console.log('ccResult', ccResult)
        if (data.full_credit_check_request) {
            const ccJson = data.full_credit_check_request
            ccResult = ccJson.status === 'failed' ? 'failed' : 'success'
        } else {
            ccResult = 'not started'
        }

        const stepsArray = [
            { title: 'CFA Signed', progress: data.cfa_signed === null ? 'NO' : 'YES' },
            { title: 'Credit Check', progress: ccResult },
            { title: 'Policy Associated', progress: data.policy_number_assigned == '1' ? 'YES' : 'NO' },
            { title: 'Cancelled', progress: data.cancelled == '1' ? 'YES' : 'NO' },
        ]
        setSteps(stepsArray)
    }, [data])

    const isComplete = (step: stepInferface) => {
        if (step.title == 'CFA Signed' && step.progress == 'YES') {
            return styles.success
        } else if ((step.title == 'CFA Signed' && step.progress == 'NO') || step.progress === null) {
            return styles.fail
        }
        if (step.title == 'Credit Check' && step.progress == 'success') {
            return styles.success
        }
        if (step.title == 'Credit Check' && step.progress == 'failed') {
            return styles.fail
        }
        if (step.title == 'Policy Associated' && step.progress == 'YES') {
            return styles.success
        }
        if (step.title == 'Policy Associated' && step.progress == 'NO') {
            return styles.fail
        }
        if (step.title == 'Cancelled' && step.progress == 'YES') {
            return styles.fail
        } else if (step.title == 'Cancelled' && step.progress == 'NO') {
            return styles.success
        }
    }

    return (
        <div className={styles.progressViewContainer}>
            <div className={styles.progressView}>
                {steps &&
                    steps?.map((step: stepInferface, k: number) => {
                        return (
                            <div key={k} className={styles.ProgressItemContainer}>
                                <div className={styles.progessCircleContainer}>
                                    <div className={`${isComplete(step)} ${styles.progessCircle}`}></div>
                                </div>
                                <p>
                                    <span>{step.title}</span>
                                    <span>{step.progress}</span>
                                </p>
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}
